/**
 * Gets if the url specified is an indexed path
 *
 * In the case of an indexed path (e.g. /mail/0/) for multiple account scenarios (Outlook/Gmail) it will return true else false.
 *
 * @param windowUrlPath the path to extract scope from, typically location.pathname
 */
export default function isIndexedPath(windowUrlPath?: string): boolean {
    if (windowUrlPath) {
        // Normalize by trimming the slashes from start and end of windowUrlPath
        let segments = windowUrlPath.split('/').filter(part => part.length);

        if (segments.length >= 2) {
            if (!isNaN(parseInt(segments[1]))) {
                return true;
            }
        }
    }

    return false;
}
